import { Tag } from '@hub/shared'
import { RecruitmentScope } from '@hub/shared/interfaces/user-in-campaign.interface'
import { useTranslation } from 'react-i18next'
import './brand-requirements.component.scoped.scss'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  scope: RecruitmentScope
}

export default ({ scope, className = '', ...props }: Props) => {
  const { t } = useTranslation('brandRequirements')
  return (
    scope && (
      <section {...props} className={`branding-requirements ${className}`}>
        <h5 className="title">{t('title')}</h5>
        <div className="tags">
          {scope?.eventParticipation ? (
            <Tag
              icon={
                <div className="icon-requirement position-relative mr-3">
                  <i className="fa-light fa-party-horn relative"></i>
                  <i className="fa-solid fa-circle-check position-absolute check-icon green" />
                </div>
              }
              labels={[t('participationIn'), <strong style={{ fontSize: '0.9rem' }}>{t('event')}</strong>]}
            />
          ) : null}
          {scope?.brandExclusivity ? (
            <Tag
              icon={
                <div className="icon-requirement position-relative mr-3">
                  <i className="fa-light fa-stars"></i>
                  <i className="fa-solid fa-circle-check position-absolute check-icon green" />
                </div>
              }
              labels={[t('brandExclusivity'), <strong style={{ fontSize: '0.9rem' }}>{t('brandExclusivityValue')}</strong>]}
            />
          ) : null}
          {scope?.imageRightsMonths ? (
            <Tag
              icon={
                <div className="icon-requirement position-relative mr-3">
                  <i className="fa-light fa-image-polaroid-user"></i>
                  <i className="fa-solid fa-circle-check position-absolute check-icon green" />
                </div>
              }
              labels={[
                t('imageRights'),
                <strong style={{ fontSize: '0.9rem' }}>{t('imageRightsMonths', { count: scope?.imageRightsMonths })}</strong>,
              ]}
            />
          ) : null}
          {scope?.contentBoost ? (
            <Tag
              icon={
                <div className="icon-requirement position-relative mr-3">
                  <i className="fa-light fa-rectangle-ad relative"></i>
                  <i className="fa-solid fa-circle-check position-absolute check-icon green" />
                </div>
              }
              labels={[t('contentBoost'), <strong style={{ fontSize: '0.9rem' }}>{t('contentBoostValue')}</strong>]}
            />
          ) : null}
        </div>
      </section>
    )
  )
}
